<template>
  <div>
    <Header />
    <LoadingDialog
      ref="LoadingDialog"
    />
    <v-container grid-list-md fluid class="container-style">
      <div class="container-header">
        <span>Student Form</span>
      </div>


      <div>
        <v-layout>
          <v-flex xs12>
            <v-card>
              <v-container grid-list-md class="fluid-full">
                <v-form
                  v-model="valid"
                  ref="form"
                  lazy-validation
                >
                  <v-layout row wrap>
                    <v-flex xs12 class="my-2">
                      <v-card>
                        <v-toolbar flat color="white" class="pt-3">
                          <v-layout row wrap>
                            <span class="title"><strong>Student Details</strong></span>
                            <v-spacer class="hide-in-mobile"></v-spacer>
                            <v-flex md3 xs12 class="mt-3">
                              <v-text-field
                                v-model="newStudent.lrn"
                                color="#091D3B"
                                label="LRN"
                                >
                              </v-text-field>
                            </v-flex>
                          </v-layout>
                        </v-toolbar>
                        <v-layout row wrap>
                          <v-flex xs12>
                            <v-card-title class="no-margin-m mx-4">
                              <v-layout row wrap>
                                <v-flex md4 xs12>
                                  <v-text-field
                                    v-model="newStudent.last_name"
                                    :rules="[v => !!v || 'Last name is required']"
                                    required
                                    color="#091D3B"
                                    label="Last Name *"
                                    >
                                  </v-text-field>
                                </v-flex>
                                <v-flex md4 xs12>
                                  <v-text-field
                                    v-model="newStudent.first_name"
                                    :rules="[v => !!v || 'First name is required']"
                                    required
                                    color="#091D3B"
                                    label="First Name *"
                                    >
                                  </v-text-field>
                                </v-flex>
                                <v-flex md4 xs12>
                                  <v-text-field
                                    color="#091D3B"
                                    v-model="newStudent.middle_name"
                                    label="Middle Name"
                                    >
                                  </v-text-field>
                                </v-flex>
                                <v-flex xs12>
                                  <v-text-field
                                    v-model="newStudent.address"
                                    :rules="[v => !!v || 'Address is required']"
                                    required
                                    color="#091D3B"
                                    label="Address *">
                                  </v-text-field>
                                </v-flex>
                                <v-flex md3 xs12>
                                  <v-menu
                                    v-model="menu"
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    lazy
                                    transition="scale-transition"
                                    offset-y
                                    full-width
                                    min-width="290px"
                                    >
                                    <template v-slot:activator="{ on }">
                                      <v-text-field
                                        v-model="newStudent.birthday"
                                        :rules="[v => !!v || 'Birthday is required']"
                                        label="Birthday *"
                                        readonly
                                        color="#091D3B"
                                        v-on="on"
                                      ></v-text-field>
                                    </template>
                                    <v-date-picker v-model="newStudent.birthday" @input="menu = false"></v-date-picker>
                                  </v-menu>
                                </v-flex>
                                <v-flex md3 xs12>
                                  <v-text-field
                                    :value="computeAge"
                                    color="#091D3B"
                                    label="Age"
                                    disabled>
                                  </v-text-field>
                                </v-flex>
                                <v-flex md3 xs12>
                                  <v-select
                                    v-model="newStudent.gender"
                                    :items="genderChoices"
                                    color="#091D3B"
                                    :rules="[v => !!v || 'Gender is required']"
                                    label="Gender *"
                                    required

                                  ></v-select>
                                </v-flex>
                                <v-flex md3 xs12>
                                  <v-text-field
                                    v-model="newStudent.religion"
                                    color="#091D3B"
                                    label="Religion"
                                    >
                                  </v-text-field>
                                </v-flex>
                                <v-flex md4 xs12>
                                  <v-text-field
                                    v-model="newStudent.telephone_number"
                                    color="#091D3B"
                                    label="Telephone Number"
                                    >
                                  </v-text-field>
                                </v-flex>
                                <v-flex md4 xs12>
                                  <v-text-field
                                    v-model="newStudent.mobile_number"
                                    color="#091D3B"
                                    label="Mobile Number"
                                    >
                                  </v-text-field>
                                </v-flex>
                                <v-flex md4 xs12>
                                  <v-text-field
                                    v-model="newStudent.nationality"
                                    color="#091D3B"
                                    label="Nationality"
                                    >
                                  </v-text-field>
                                </v-flex>
                              </v-layout>
                            </v-card-title>
                          </v-flex>
                        </v-layout>
                      </v-card>
                    </v-flex>

                    <v-flex xs12 class="my-2">
                      <v-card>
                        <v-toolbar flat color="white" class="pt-2">
                          <span class="title"><strong>Parents Information</strong></span>
                          <v-spacer></v-spacer>
                        </v-toolbar>
                        <v-layout row wrap>
                          <v-flex xs12>
                            <v-card-title class="no-margin-m mx-4">
                              <v-layout row wrap>
                                <v-flex md4 xs12>
                                  <v-text-field
                                    v-model="newStudent.father_name"
                                    color="#091D3B"
                                    label="Father's Name"
                                    >
                                  </v-text-field>
                                </v-flex>
                                <v-flex md4 xs12>
                                  <v-text-field
                                    v-model="newStudent.father_occupation"
                                    color="#091D3B"
                                    label="Father's occupation"
                                    >
                                  </v-text-field>
                                </v-flex>
                                <v-flex md4 xs12>
                                  <v-text-field
                                    v-model="newStudent.father_company"
                                    color="#091D3B"
                                    label="Father's Company"
                                    >
                                  </v-text-field>
                                </v-flex>

                                <v-flex md4 xs12>
                                  <v-text-field
                                    v-model="newStudent.mother_name"
                                    color="#091D3B"
                                    label="Mother's Name"
                                    >
                                  </v-text-field>
                                </v-flex>
                                <v-flex md4 xs12>
                                  <v-text-field
                                    v-model="newStudent.mother_occupation"
                                    color="#091D3B"
                                    label="Mother's Occupation"
                                    >
                                  </v-text-field>
                                </v-flex>
                                <v-flex md4 xs12>
                                  <v-text-field
                                    v-model="newStudent.mother_company"
                                    color="#091D3B"
                                    label="Mother's Company"
                                    >
                                  </v-text-field>
                                </v-flex>
                              </v-layout>
                            </v-card-title>
                          </v-flex>
                        </v-layout>
                      </v-card>
                    </v-flex>

                    <v-flex md6 xs12 class="my-2">
                      <v-card>
                        <v-toolbar flat color="white" class="pt-2">
                          <span class="title"><strong>Other Informations</strong></span>
                          <v-spacer></v-spacer>
                        </v-toolbar>
                        <v-layout row wrap>
                          <v-flex xs12>
                            <v-card-title class="no-margin-m mx-4">
                              <v-layout row wrap>
                                <v-flex xs12>
                                  <v-text-field
                                    v-model="newStudent.language_spoken_at_home"
                                    color="#091D3B"
                                    label="Language spoken at home"
                                    >
                                  </v-text-field>
                                </v-flex>
                                <v-flex xs12>
                                  <v-text-field
                                    v-model="newStudent.previous_school"
                                    color="#091D3B"
                                    label="Previous School"
                                    >
                                  </v-text-field>
                                </v-flex>
                                <v-flex xs12>
                                  <v-textarea
                                    v-model="newStudent.special_information"
                                    color="#091D3B"
                                    label="Special Information about child (allergies, handicaps, food, etc.)"
                                    >
                                  </v-textarea>
                                </v-flex>
                              </v-layout>
                            </v-card-title>
                          </v-flex>
                        </v-layout>
                      </v-card>
                    </v-flex>

                    <v-flex xs12 md6 class="my-2">
                      <v-card>
                        <v-toolbar flat color="white" class="pt-2">
                          <span class="title"><strong>Documents</strong></span>
                          <v-spacer></v-spacer>
                        </v-toolbar>
                        <v-layout row wrap>
                          <v-flex xs12>
                            <v-card-title class="no-margin-m mx-4">
                              <v-layout row wrap>
                                <v-flex xs12>
                                  <v-checkbox
                                    style="margin-top: 0; padding-top:0;"
                                    v-model="newStudent.birth_certificate_submitted"
                                    label="Photo copy of Birth Certificate"></v-checkbox>
                                  <v-checkbox
                                    style="margin-top: 0; padding-top:0;"
                                    v-model="newStudent.report_card_submitted"
                                    label="Card - F138"></v-checkbox>
                                  <v-checkbox
                                    style="margin-top: 0; padding-top:0;"
                                    v-model="newStudent.good_moral_submitted"
                                    label="Certificate of Good Moral Character"></v-checkbox>
                                </v-flex>
                                <v-flex xs12>
                                  <v-textarea
                                    class="important-modal"
                                    v-model="newStudent.admin_notes"
                                    color="#091D3B"
                                    label="Admin Notes"
                                    box
                                    >
                                  </v-textarea>
                                </v-flex>
                              </v-layout>
                            </v-card-title>
                          </v-flex>
                        </v-layout>
                      </v-card>
                    </v-flex>
                  </v-layout>
                </v-form>
                <v-layout row>
                  <v-flex xs12>
                    <div>
                      <v-toolbar flat color="transparent" class="v-toolbar-button">
                        <v-spacer></v-spacer>
                        <v-btn color="#091D3B" outline @click="cancel">Back</v-btn>
                        <v-btn class="button-style-blue" @click="submitUserForm">Save</v-btn>
                      </v-toolbar>
                    </div>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card>
          </v-flex>
        </v-layout>
      </div>
    </v-container>
  </div>
</template>
<script type="text/javascript">
import { mapState, mapActions } from 'vuex';
import Header from '@/components/Header.vue'
import LoadingDialog from '@/components/LoadingDialog.vue'

export default {
  components: {
    Header,
    LoadingDialog,
  },
  computed: {
    ...mapState([
        'enrollments',
        'payment',
        'schoolYears',
        'student'
    ]),
    computeAge () {
      if (this.newStudent.birthday) {
        const date_by_june = this.$moment().month(5)
        const student_birthday_by_june = this.$moment.duration(this.$moment(date_by_june).diff(this.newStudent.birthday));
        return student_birthday_by_june.years() + " years, " + student_birthday_by_june.months() + " months"
      } else {
        return
      }
    }
  },
  data () {
    return {
      valid: true,
      date: '',
      menu: '',
      documents: [],
      inputRules: [
        v => !!v || 'This field is required'
      ],
      genderChoices: [
        { value: 'M', text: 'Male'},
        { value: 'F', text: 'Female' }
      ],
      newStudent: {
        last_name: '',
        first_name: '',
        middle_name: '',
        address: '',
        birthday: '',
        age: '',
        lrn: '',
        gender: '',
        telephone_number: '',
        mobile_number: '',
        nationality: 'Filipino',
        religion: '',
        language_spoken_at_home: '',
        previous_school: '',
        special_information: '',
        father_name: '',
        father_occupation: '',
        father_company: '',
        mother_name: '',
        mother_occupation: '',
        mother_company: '',
        birth_certificate_submitted: false,
        report_card_submitted: false,
        good_moral_submitted: false,
        admin_notes: ''
      }
    }
  },
  methods: {
    ...mapActions(["addStudent", "updateStudent", "getStudentById"]),
    submitUserForm () {
      if (this.$refs.form.validate()) {
        if (this.newStudent.id) {
          this.update()
        } else {
          this.add()
        }
      }
    },
    add () {
      let self = this
      this.addStudent(this.newStudent)
        .then((data) => {
          self.$toastr("info", "Student added", "info");
          self.$router.push({ name: 'student-detail', params: {id: data.id} })
        })
        .catch((errors) => {
          self.$toastr("error", errors, "error");
        })
    },
    update () {
      let self = this
      this.updateStudent(this.newStudent)
        .then((data) => {
          self.$toastr("success", "Student updated", "");
          self.$router.push({ name: 'student-detail', params: {id: data.id} })
        })
        .catch((errors) => {
          self.$toastr("error", errors, "error");
        })
    },
    cancel() {
      if (this.$route.params.id) {
        this.$router.push({
          name: 'student-detail', id: this.$route.params.id
        });
      } else {
        this.$router.push({
          name: 'student-list'
        });
      }
    }
  },
  created() {
    let self = this
    if (this.$route.name == "update-student") {
      this.getStudentById({ id: this.$route.params.id })
        .then((data) => {
          self.newStudent = self.student
        })
    }
  }
}
</script>
